<template>
  <div>
    <div class="content-devx">
      <f7-block>
        <span class="bold">{{ $t('registerPlantation.step2') }}</span>  {{ $t('registerPlantation.subtitle_step2') }}
      </f7-block>
      <f7-block>
        <DxForm
          id="form"
          :col-count="1"
          :caption="$t('title_register_plantation')"
        >
          <DxGroupItem :col-count="2">
            <DxSimpleItem
              :data-field="$t('registerPlantation.plantationName')"
              name="name"
              :editor-options="{
                value: plantationName,
                showClearButton: true,
                onValueChanged: onChangeName,
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
            <DxSimpleItem
              name="cultive_type"
              :data-field="$t('registerPlantation.cultive_type')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: cropTypes,
                value: cropTypeSelected,
                onValueChanged: onChangeCultiveType,
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
            <DxSimpleItem
              name="protected"
              :data-field="$t('registerPlantation.protected')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: protectionTypes,
                value: protectionTypeSelected,
                onValueChanged: onChangeProtectionType,
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
            <DxSimpleItem
              :data-field="$t('registerPlantation.init_date')"
              name="init_date"
              editor-type="dxDateBox"
              :editor-options="{
                onValueChanged: onChangeInitDate,
                value: initDate,
                displayFormat: 'dd/MM/yyyy',
                invalidDateMessage: $t('dates_isInvalid'),
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
            <DxSimpleItem
              name="manejo"
              :data-field="$t('registerPlantation.manejo')"
              editor-type="dxSelectBox"
              :editor-options="{
                items: managementTypes,
                value: managementTypeSelected,
                onValueChanged: onChangeManagement,
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
            <DxSimpleItem
              name="end-date"
              :data-field="$t('registerPlantation.end_date')"
              editor-type="dxDateBox"
              :editor-options="{
                onValueChanged: onChangeEndDate,
                value: endDate,
                displayFormat: 'dd/MM/yyyy',
                invalidDateMessage: $t('dates_isInvalid'),
              }"
            >
              <DxRequiredRule message="" />
            </DxSimpleItem>
          </DxGroupItem>
        </DxForm>
      </f7-block>
    </div>
    <div v-if="cropTypeSelected === 'HORTÍCOLA'">
      <RegisterHorticola
        :species-availables="speciesAvailables"
      />
    </div>
    <div v-if="cropTypeSelected === 'HERBÁCEO'">
      <RegisterHebacea
        :species-availables="speciesAvailables "
      />
    </div>
    <div v-if="cropTypeSelected === 'LEÑOSO'">
      <RegisterLenioso
        :species-availables="speciesAvailables"
      />
    </div>
    <DxPopUPRegisterParcelSectorByPlantation
      :parcels="parcels"
      :sectors="sectors"
    />
  </div>
</template>

<script>
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
} from 'devextreme-vue/form';
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import RegisterHorticola from '../registerHorticola/index.vue';
import RegisterHebacea from '../registerHerbaceas/index.vue';
import RegisterLenioso from '../registerLeñoso/index.vue';
import DxPopUPRegisterParcelSectorByPlantation from '../popUpSelectParcelSector/index.vue';

export default {
  name: 'RegisterPlantationStep2',
  components: {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    RegisterHorticola,
    RegisterHebacea,
    RegisterLenioso,
    DxPopUPRegisterParcelSectorByPlantation,
    DxRequiredRule,
  },
  props: {
    cropTypes: { type: Array, default: () => [] },
    managementTypes: { type: Array, default: () => [] },
    protectionTypes: { type: Array, default: () => [] },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('RegisterPlantation', ['actualPlantation', 'parcels', 'sectors', 'isEdit', 'cropTypeSelected', 'speciesAvailables',
      'isEdit', 'initDate', 'endDate', 'managementTypeSelected', 'protectionTypeSelected', 'plantationName']),
  },
  beforeMount() {
    if (this.isEdit) {
      this.setPlantationName(this.actualPlantation.name);
      this.setInitDate(this.actualPlantation.init_date);
      this.setEndDate(this.actualPlantation.end_date);
      this.setManagementType(this.actualPlantation.management);
      this.setProtectionType(this.actualPlantation.protection);
      this.setCultiveType(this.actualPlantation.crop_type);
    }
  },
  methods: {
    onChangeName(e) {
      this.setPlantationName(e.value);
    },
    onChangeInitDate(e) {
      this.setInitDate(moment(e.value).format('YYYY-MM-DD'));
    },
    onChangeEndDate(e) {
      this.setEndDate(moment(e.value).format('YYYY-MM-DD'));
    },
    onChangeManagement(e) {
      this.setManagementType(e.value);
    },
    onChangeProtectionType(e) {
      this.setProtectionType(e.value);
    },
    async onChangeCultiveType(e) {
      this.setCultiveType(e.value);
      // this.resetSpecieSelectedAndVarietySelected(); TODO: EN LA EDICION SE RESETEA DESPUES DE DARLE VALOR AL FORMULARIO DINAMICO POR LO QUE SE QUEDA VACIO
      try {
        if (e.value !== '') {
          await this.getSelectBoxSpecies(e.value);
        }
      } catch (error) {
        const message = this.$helpers.getFilteredErrorMessage(error);
        if (message.includes('default_') && !message.includes('404')) {
          this.$f7.dialog.alert(message.split('_').pop());
        } else if (!message.includes('404')) {
          this.$f7.dialog.alert(this.$t(message));
        }
      }
    },
    ...mapActions('RegisterPlantation', ['setPlantationName', 'setProtectionType', 'setManagementType',
      'setInitDate', 'setEndDate', 'setCultiveType', 'getSelectBoxSpecies', 'resetSpecieSelectedAndVarietySelected',
      'initStore']),
  },
};
</script>
